import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Play, Radio } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SHOWS = [
  {
    slug: 'treat-your-business',
    title: 'Treat Your Business',
    host: 'Katie Bell',
    tint: 'linear-gradient(160deg, #BC516F 0%, #A7468A 55%, #81162A 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2090945.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/treat-your-business/id1616187313',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/94/15/87/941587b0-5574-1a38-c078-1378079809fe/mza_11066063311020046754.jpg/300x300bb.jpg',
    range: 'latest',
    take: 4,
  },
  {
    slug: 'beyond-the-clinic',
    title: 'Beyond the Clinic',
    host: 'Sarah Almond Bushell',
    tint: 'linear-gradient(160deg, #A7468A 0%, #81162A 50%, #1E2A44 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2320439.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/beyond-the-clinic/id1747019321',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/27/ed/5f/27ed5f13-3f61-5ab2-4b6a-6be022510493/mza_956745936563781518.jpg/300x300bb.jpg',
    // Sarah's launch series — we only show episodes from the first 30 we produced,
    // never her current output. The Buzzsprout feed lists newest first, so the
    // early episodes we worked on live at the END of the array.
    range: 'launch',
    launchCap: 30,
    take: 4,
  },
  {
    slug: 'beyond-the-words',
    title: 'Beyond the Words',
    host: 'Dimple Thakrar',
    tint: 'linear-gradient(160deg, #BC516F 0%, #E0A8B8 40%, #81162A 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2246693.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/beyond-the-words/id1723199286',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/e8/fb/56/e8fb56d7-f5c0-5b07-9677-5340111080f0/mza_9382845821145882332.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 3,
  },
  {
    slug: 'future-proof-your-business',
    title: 'Future-Proof Your Business',
    host: 'Lucy Rennie',
    tint: 'linear-gradient(160deg, #A7468A 0%, #BC516F 50%, #1E2A44 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2276976.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1737421638',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/be/72/c7/be72c775-afb2-1a79-f525-0b23168a3950/mza_11592062604956210356.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 3,
  },
  {
    slug: 'the-scrumptious-woman',
    title: 'The Scrumptious Woman',
    host: 'Juliette Karaman',
    tint: 'linear-gradient(160deg, #E0A8B8 0%, #BC516F 45%, #A7468A 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2208024.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1698620594',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/2c/f5/b5/2cf5b551-f209-a0db-3651-7649ef1bfeea/mza_5565.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 3,
  },
  {
    slug: 'the-cut-flower-podcast',
    title: 'The Cut Flower Podcast',
    host: 'Roz Chandler',
    tint: 'linear-gradient(160deg, #BC516F 0%, #A7468A 50%, #E0A8B8 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/1491655.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1520763648',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/7e/54/a7/7e54a797-35a4-5718-da99-b4ac2ccb0d48/mza_3578902708311632652.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 2,
  },
  {
    slug: 'ask-dr-jodi',
    title: 'Ask Dr. Jodi',
    host: 'Dr. Jodi Aman',
    tint: 'linear-gradient(160deg, #A7468A 0%, #E0A8B8 45%, #BC516F 100%)',
    rssFeed: 'https://feeds.simplecast.com/ie6KAqyJ',
    listenUrl: 'https://podcasts.apple.com/podcast/id1784567047',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/e9/f4/06/e9f406c7-ec72-befc-c83e-cf777a68fe5f/mza_8505560877737041918.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 2,
  },
  {
    slug: 'the-calling',
    title: 'The Calling',
    host: 'Homaya',
    tint: 'linear-gradient(160deg, #81162A 0%, #A7468A 50%, #BC516F 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2253958.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1723199286',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/e6/57/fa/e657fab0-bcff-15e4-6d2c-de9cd2f5bfb2/mza_7770022858614241784.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 2,
  },
  {
    slug: 'the-miracle-zone',
    title: 'The Miracle Zone',
    host: 'Catarine Andrade',
    tint: 'linear-gradient(160deg, #BC516F 0%, #81162A 50%, #A7468A 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2451031.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1798757549',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/7b/66/d5/7b66d50a-fe6b-ea6a-5f2d-93e4ba8951a7/mza_11113047695026928611.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 2,
  },
  {
    slug: 'the-human-design-channel',
    title: 'The Human Design Channel',
    host: 'Karen McMullen',
    tint: 'linear-gradient(160deg, #A7468A 0%, #BC516F 40%, #81162A 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2464994.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1805546951',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/96/b9/2d/96b92d41-ef9e-51b3-36a2-e8a3b16ca8e2/mza_10609962401352210145.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 2,
  },
  {
    slug: 'my-mighty-quinn',
    title: 'My Mighty Quinn',
    host: 'Lucia Silver',
    tint: 'linear-gradient(160deg, #E0A8B8 0%, #A7468A 50%, #1E2A44 100%)',
    rssFeed: 'https://feeds.buzzsprout.com/2227644.rss',
    listenUrl: 'https://podcasts.apple.com/podcast/id1713350863',
    coverFallback: 'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/38/d3/71/38d37109-1373-d128-3dea-7ca09cb897a4/mza_8368873268412536214.jpg/300x300bb.jpg',
    range: 'beforeDate',
    beforeDate: '2025-05-01',
    take: 2,
  },
];

function formatDuration(secs) {
  const s = parseInt(secs || 0, 10);
  if (!s) return null;
  const m = Math.floor(s / 60);
  return `${m} min`;
}
function formatDate(pub) {
  if (!pub) return null;
  try {
    const d = new Date(pub);
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  } catch { return null; }
}

/**
 * WeeklyShippingWall — horizontal scroll of client-show tiles.
 * Data pulled live from RSS feeds; presentation is factual only
 * (cover, show, title, duration, date). No editorial framing.
 */
export default function WeeklyShippingWall() {
  const [episodes, setEpisodes] = useState([]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const all = [];
      for (const s of SHOWS) {
        try {
          // Launch and beforeDate shows need the full feed so we can safely
          // pick only the episodes we actually produced. Latest shows only need N.
          const requestedLimit = (s.range === 'launch' || s.range === 'beforeDate') ? 0 : (s.take || 5);
          const r = await axios.get(`${API}/podcasts/parse-rss`, {
            params: { rss_url: s.rssFeed, limit: requestedLimit },
            timeout: 12000,
          });
          const allEps = r.data?.episodes || [];
          let picked = [];
          if (s.range === 'launch') {
            const cap = s.launchCap || 30;
            // Safety guard — never fall back to "newest" for a launch show.
            if (allEps.length > cap) {
              picked = allEps.slice(-cap).reverse().slice(0, s.take || 5);
            } else {
              picked = [];
            }
          } else if (s.range === 'beforeDate') {
            // Hard cutoff — only show episodes published strictly BEFORE beforeDate.
            // Never fall back to newest; if parsing fails, show nothing for that show.
            const cutoff = new Date(s.beforeDate).getTime();
            if (!Number.isFinite(cutoff)) {
              picked = [];
            } else {
              const safe = allEps.filter((e) => {
                const t = e.published ? new Date(e.published).getTime() : NaN;
                return Number.isFinite(t) && t < cutoff;
              });
              picked = safe.slice(0, s.take || 5);
            }
          } else {
            picked = allEps.slice(0, s.take || 5);
          }
          const eps = picked.map((e) => ({
            show: s,
            title: e.title,
            duration: formatDuration(e.duration),
            published: formatDate(e.published),
            cover: r.data?.cover_art || s.coverFallback,
          }));
          all.push(...eps);
        } catch {
          // Silent — the wall just skips this show rather than fabricate.
        }
      }
      // Interleave shows across the strip so the eye jumps between covers.
      const bySlug = SHOWS.reduce((acc, s) => { acc[s.slug] = []; return acc; }, {});
      for (const e of all) { bySlug[e.show.slug].push(e); }
      const woven = [];
      const max = Math.max(...Object.values(bySlug).map((a) => a.length));
      for (let i = 0; i < max; i++) {
        for (const s of SHOWS) {
          if (bySlug[s.slug][i]) woven.push(bySlug[s.slug][i]);
        }
      }
      if (!cancelled) setEpisodes(woven);
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="relative bg-[#0B0E1A] py-20 sm:py-24 overflow-hidden" data-testid="weekly-shipping-wall">
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[820px] h-[420px] rounded-full bg-[#A7468A]/15 blur-3xl pointer-events-none v2-blob" aria-hidden="true" />
      <div className="max-w-[1120px] mx-auto px-5 sm:px-6 lg:px-8 mb-10">
        <p className="text-[#E0A8B8] font-semibold text-sm uppercase tracking-[0.2em] flex items-center gap-3">
          <span className="w-8 h-px bg-[#E0A8B8]/60" />
          Client shows
        </p>
        <h2 className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 leading-[1.05]">
          A selection of our favourite past and present <span className="v2-shimmer">client podcasts</span>.
        </h2>
        <p className="mt-5 text-white/70 text-lg leading-relaxed max-w-3xl">
          Real shows, real episodes. Tap any tile to listen.
        </p>
      </div>

      {/* Horizontal scroll strip */}
      <div className="relative">
        <div
          className="flex gap-5 overflow-x-auto snap-x snap-mandatory scrollbar-hide px-5 sm:px-6 lg:px-8 pb-4"
          style={{ scrollbarWidth: 'none' }}
        >
          {episodes.length === 0 && (
            <div className="text-white/40 py-10">Loading real episodes…</div>
          )}
          {episodes.map((ep, i) => (
            <a
              key={i}
              href={ep.show.listenUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex-shrink-0 snap-start w-[220px] sm:w-[240px]"
              data-testid={`ship-tile-${i}`}
            >
              {/* Phone frame */}
              <div className="relative w-full aspect-[9/16] rounded-[26px] bg-[#0B0E1A] p-2 border-2 border-white/10 shadow-[0_25px_60px_-20px_rgba(188,81,111,0.5)] transition-transform duration-500 group-hover:-translate-y-2 group-hover:shadow-[0_35px_80px_-15px_rgba(188,81,111,0.7)]">
                <div className="w-full h-full rounded-[20px] overflow-hidden relative" style={{ background: ep.show.tint }}>
                  {/* Cover art at top */}
                  <img
                    src={ep.cover}
                    alt={`${ep.show.title} podcast cover art, a weekly show shipped by Audio & Co. podcast management`}
                    title={`${ep.show.title} | Audio & Co.`}
                    width="240"
                    height="240"
                    loading="lazy"
                    className="w-full h-1/2 object-cover"
                  />
                  {/* Duration only — no editorialising badges */}
                  {ep.duration && (
                    <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-white text-[10px] font-bold px-2 py-0.5 rounded">
                      {ep.duration}
                    </div>
                  )}
                  {/* Play button in the middle */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/95 flex items-center justify-center shadow-lg transition-transform duration-500 group-hover:scale-110" style={{ marginTop: '-25%' }}>
                    <Play className="w-5 h-5 text-[#81162A]" fill="currentColor" />
                  </div>
                  {/* Content area — factual only */}
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                    <div className="text-[10px] font-semibold uppercase tracking-widest opacity-70">{ep.show.title}</div>
                    <div className="text-[13px] font-semibold leading-tight mt-1 line-clamp-3">{ep.title}</div>
                    {ep.published && (
                      <div className="text-[10px] mt-2 opacity-60 flex items-center gap-1">
                        <Radio className="w-2.5 h-2.5" />
                        <span>{ep.published}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
